
export const DEFAULT_DISCOUNT = 30

export const DEFAULT_PRICE = 96000

export const calculatePrice = ({
  price = DEFAULT_PRICE,
  discount = DEFAULT_DISCOUNT,
  discountMonths,
  locale,
  semestersNumber = 2
}: {
  price: number | null | undefined
  discount: number | null | undefined
  locale: string | undefined
  discountMonths?: number | undefined | null
  semestersNumber?: number
}) => {
  const currencySymbol = '₽'

  const rounds = (locale === 'en' && 10) || 100

  const regularPrice = (price && Number(price)) || DEFAULT_PRICE

  const discountValue = (discount && Number(discount)) || 0

  const discountedPrice =
    discountValue > 0
      ? Math.round((regularPrice * (100 - discountValue)) / 100)
      : regularPrice

  const regularPriceSemester =
    Math.round(Math.ceil(regularPrice / semestersNumber) / rounds) * rounds

  const discountedPriceSemester =
    Math.round(Math.ceil(discountedPrice / semestersNumber) / rounds) * rounds

  const regularPriceOneMonth =
    Math.round(Math.ceil(regularPrice / (discountMonths ?? 12)) / (rounds / 10)) * (rounds / 10)

  const discountedPriceOneMonth =
    Math.round(Math.ceil(discountedPrice / (discountMonths ?? 12)) / (rounds / 10)) * (rounds / 10)

  return {
    total: {
      price: discountedPrice,
      regularPrice
    },
    oneSemisterPayment: {
      name:
        semestersNumber === 1
          ? 'Стоимость программы за весь курс'
          : 'Оплата за один семестр',
      price: discountedPriceSemester,
      regularPrice: regularPriceSemester,
      currencySymbol
    },
    yearInstallmentPlan: {
      name: `Рассрочка без переплат на ${discountMonths} ${discountMonths == 24 ? 'месяца' : 'месяцев'}`,
      price: discountedPriceOneMonth,
      regularPrice: regularPriceOneMonth,
      currencySymbol: `${currencySymbol} '/мес'`
    }
  }
}
